import * as React from 'react'

const SvgBlogIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 15h6.25v1.25H2.5V15zm0-3.75h6.25v1.25H2.5v-1.25zm13.75-2.5H3.75c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25V7.5c0 .69-.56 1.25-1.25 1.25zm-12.5-5V7.5h12.5V3.75H3.75zm12.5 13.75H12.5c-.69 0-1.25-.56-1.25-1.25V12.5c0-.69.56-1.25 1.25-1.25h3.75c.69 0 1.25.56 1.25 1.25v3.75c0 .69-.56 1.25-1.25 1.25zm-3.75-5v3.75h3.75V12.5H12.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgBlogIcon
